var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../libs/dragscroll');
var auth = require('../auth/models/session');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var heading = require('../components/heading');
var modalForm = require('../layout/components/modalForm');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var bacnetServerModel = require('../bacnet/models/bacnetServer');
var scDiscoveryModal = require('../bacnet/scDiscoveryModal');
var bacnetServer = modalForm(bacnetServerModel);
var cnipServer = modalForm(require('../lontalk/models/cnipServer'));
var modbusTcpForm = modalForm(require('../modbus/models/modbusTcp'));
var restHttpModel = require('../rest/models/restHttp');
var restHttpForm = modalForm(restHttpModel);
var networkTreeTransferModal = require('./treeTransferModal');
var agentGatewayStatusStore = require('./agentGatewayStatusStore');
var tableColumns = require('./components/tableColumns');
var bacnetPresentation = require('../bacnet/deviceDiscoveryPresentation');
var requestState = require('./requestState');

var forms = [bacnetServer, cnipServer, modbusTcpForm, restHttpForm];

var networks = {};

function isEnabled(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function canEditHosts() {
  return edit.vm.editing() && auth.user().isSuperuser == 1;
}

function enabledBoolBox(value, label, onclick) {
  var enabled = isEnabled(value);
  var clickable = typeof onclick === 'function';
  var classes = 'h1.w1.ba.b--blue' + (enabled ? '.bg-blue' : '');
  var tag = clickable ? 'button.bn.bg-transparent.pa0.dib' : 'span.dib';
  var attrs = clickable
    ? {
        type: 'button',
        onclick: onclick,
        title: 'Edit ' + label,
        'aria-label': 'Edit ' + label + ' enabled setting',
        style: { cursor: 'pointer' }
      }
    : {
        role: 'img',
        title: enabled ? 'Enabled' : 'Disabled',
        'aria-label': label + (enabled ? ' enabled' : ' disabled')
      };
  return m(tag, attrs, [
    m('div.' + classes, {
      style: { backgroundClip: 'content-box', padding: '2px' }
    })
  ]);
}

function renderAgentStatus(host) {
  var status = agentGatewayStatusStore.statusForRecord(host);
  return m('span.' + agentGatewayStatusStore.statusClass(status), status);
}

function hostDestinationPort(host) {
  if (!host) return '';
  if (host['@class'] === 'BacnetServer') {
    if (host.transport === 'bacnet-sc') return 'SC';
    return host.destinationPort || host.port || '';
  }
  return host.port || '';
}

function hostAddress(host) {
  if (!host) return '';
  if (host['@class'] === 'BacnetServer' && host.transport === 'bacnet-sc') {
    return bacnetPresentation.formatVmac(host.targetVmac || '');
  }
  return host.host || '';
}

function hostType(host) {
  if (host && host['@class'] === 'BacnetServer') return 'BACnet Host';
  return host && host['@class'];
}

function ridText(value) {
  if (value && value['@rid']) value = value['@rid'];
  var text = String(value == null ? '' : value);
  return text && text !== '[object Object]' ? text : '';
}

function connectionName(host, connectionsByRid) {
  if (!host || host['@class'] !== 'BacnetServer' || host.transport !== 'bacnet-sc') return '';
  var connection = connectionsByRid[ridText(host.scConnection)];
  return connection ? connection.name : ridText(host.scConnection);
}

function rowActions(form, host, ctrl) {
  return [
    {
      label: 'Edit Host',
      icon: 'ion-ios-compose',
      onclick: function () { form.editDialogue(host, {submitCallback: ctrl.init}); }
    },
    {
      label: 'Delete Host',
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { form.deleteDialogue(host, {dashboardCallback: ctrl.init}); }
    }
  ];
}

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

networks.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Networks');
  document.title = 'nimrod | Hosts';
  ctrl.newNode = prop(false);
  requestState.initialize(ctrl);

  ctrl.init = function(){
    return requestState.run(ctrl, function () {
      return Promise.all([
        loaders.requestWithLoader({
          url: '/api/v1/host/',
          method: 'GET'
        }),
        loaders.requestWithLoader({
          url: '/api/v1/bacnetscconnection',
          method: 'GET',
          loader: 'background'
        }).catch(function () { return []; })
      ]).then(function (results) {
        var connectionsByRid = {};
        (results[1] || []).forEach(function (connection) {
          connectionsByRid[ridText(connection['@rid'])] = connection;
        });
        ctrl.networks = (results[0] || []).map(function (host) {
          host.connectionName = connectionName(host, connectionsByRid);
          return host;
        });
        ctrl.newNode(true);
      });
    });
  }
  ctrl.networksToShow = [];
  ctrl.unsubscribeAgentStatus = agentGatewayStatusStore.subscribe(function () {
    m.redraw();
  });
  ctrl.init();
}

networks.onremove = function () {
  if (this.unsubscribeAgentStatus) this.unsubscribeAgentStatus();
};

networks.view = function () {
  var ctrl = this;
  var stateView = requestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.networks){
    return m('div');
  }
  return m('div.mh3', [
    m(heading, {
      label:'Hosts', 
      class:'f-subheadline mb3 pb1 display'
    },[
      canEditHosts() ? m(rowActionDropdown, {
        items: [
          {
            label: 'New BACnet Host',
            icon: 'ion-plus',
            onclick: () => bacnetServer.editDialogue({},{submitCallback: ctrl.init})
          },
          {
            label: 'Discover BACnet/SC Devices',
            icon: 'ion-search',
            onclick: () => scDiscoveryModal.open(ctrl.init)
          },
          {
            label: 'New CNIP Server',
            icon: 'ion-plus',
            onclick: () => cnipServer.editDialogue({},{submitCallback: ctrl.init})
          },
          {
            label: 'New Modbus Tcp',
            icon: 'ion-plus',
            onclick: () => modbusTcpForm.editDialogue({},{submitCallback: ctrl.init})
          },
          {
            label: 'New Rest HTTP',
            icon: 'ion-plus',
            onclick: () => restHttpForm.editDialogue({},{submitCallback: ctrl.init})
          },
          {
            label: 'Import Network Trees',
            icon: 'ion-upload',
            onclick: () => networkTreeTransferModal.openNetworkImportModal(ctrl.init)
          },
          {
            label: 'Export Network Trees',
            icon: 'ion-document-text',
            onclick: () => networkTreeTransferModal.openNetworkExportModal(ctrl.networks)
          }
        ]
      }) : ''
    ]),
    m(paginationWithSearch, {
      data: ctrl.networks,
      newNode: ctrl.newNode,
      dataToShow: ctrl.networksToShow,
      placeHolder: 'Search host',
      itemsPerPage: 30,
      fieldsToSearch: ['name', 'host', 'targetVmac', 'transport', 'connectionName', 'destinationPort', 'port', '@class']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.fw2.f4.narrow.mb4.pt3.mr4', [
              tableColumns.colgroup([
                { key: 'name', width: '21%' },
                { key: 'type', width: '14%' },
                { key: 'host', width: '18%' },
                { key: 'connection', width: '15%' },
                { key: 'port', width: '8%' },
                { key: 'status', width: '12%' },
                { key: 'enabled', width: '12%' }
              ]),
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Name'),
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Type'),
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Address / Destination'),
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Connection'),
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Destination Port'),
                  m('th.ph0.tl.v-btm.fw2.bb.b--mid-gray.bw1', 'Status'),
                  m('th.ph0.tl.v-btm.ph2.fw2.bb.b--mid-gray.bw1', 'Enabled'),
                ])
              ]),
              m('tbody', [
                ctrl.networksToShow.map(function (host) {
                  if (!host['@rid']) {
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data')  
                      ]),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap')
                    ])
                  }else{
                    let form = forms.filter(r => r['@class'] == host ['@class'])[0];
                    return m('tr', [
                      m('td.tl.nowrap', [
                        m('div.flex.items-center.justify-between', [
                          m(m.route.Link, {
                            href: `/${host['@class'].toLowerCase()}/${host['@rid'].slice(1)}`
                          }, host.name),
                          m('div.ml3.flex-none', [
                            actionDropdown(rowActions(form, host, ctrl))
                          ])
                        ])
                      ]),
                      m('td.tl.nowrap', hostType(host)),
                      m('td.tl.nowrap.mono', hostAddress(host)),
                      m('td.tl.nowrap', host.connectionName || '—'),
                      m('td.tl.nowrap', hostDestinationPort(host)),
                      m('td.tl.nowrap', renderAgentStatus(host)),
                      m('td.tl.nowrap', [
                        enabledBoolBox(
                          host.enabled,
                          host.name || 'Host',
                          canEditHosts() && form
                            ? function () { form.editDialogue(host, {submitCallback: ctrl.init}); }
                            : null
                        )
                      ])
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
};
module.exports = networks;
